import { Helmet, HelmetProvider } from 'react-helmet-async';

import { useAppSelector } from '@/store/hooks';

function SeoContainer({ children }: React.PropsWithChildren) {
  const seoState = useAppSelector(state => state.seo);

  return (
    <HelmetProvider>
      <Helmet>
        {/* React Helmet seems to be a bit ...problematic; as soon as we declare
        a tag in index.html as up-for-grabs (via 'data-rh="true"), it'll immediately
        defer to this tag to overwrite it; if a tag doesn't exist, it gets removed... */}
        <title>{seoState.title}</title>
        <meta name="description" content={seoState.description} />
        <meta property="og:title" content={seoState.title} />
        <meta property="og:image" content={seoState.imageUrl} />
        <meta property="og:site_name" content={seoState.siteName} />
        <meta property="og:description" content={seoState.description} />
        <meta name="twitter:title" content={seoState.title} />
        <meta name="twitter:description" content={seoState.description} />
        <meta name="twitter:image" content={seoState.imageUrl} />
      </Helmet>

      {children}
    </HelmetProvider>
  );
}

export default SeoContainer;
